export const CURRENT_LEGAL_VERSION = "v1.0.0";

export const LEGAL_DOCUMENTS = {
  terms: {
    title: "Terms and Conditions of Service",
    content: `
# Terms and Conditions of Service

**Last Updated:** July 16, 2026
**Version:** v1.0.0

Welcome to Finaculator. By accessing or using our application, you agree to be bound by these Terms and Conditions ("Terms"). If you disagree with any part of the terms, you may not access the service.

## 1. Acceptance of Terms
By creating an account, logging in, or using any part of our service, you acknowledge that you have read, understood, and agree to be bound by these Terms. Acceptance is recorded with a secure timestamp and document version.

## 2. Description of Service
Finaculator provides a cloud-based ledger for microfinance and daily collections. We offer tools for tracking loans, managing installments, and sharing account statements.

## 3. User Responsibilities
- You are responsible for maintaining the confidentiality of your account credentials.
- You agree to provide accurate and complete information when entering financial records.
- You must comply with all applicable local financial laws and regulations when using this platform.

## 4. Limitation of Liability
Finaculator is provided "as is" without any warranties. We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.

## 5. Modifications to Terms
We reserve the right to modify these terms at any time. When updates occur, you will be required to accept the new version before continuing to use the service.
    `
  },
  privacy: {
    title: "Privacy Policy",
    content: `
# Privacy Policy

**Last Updated:** July 16, 2026
**Version:** v1.0.0

Your privacy is critically important to us. This policy explains how we collect, use, and protect your personal information.

## 1. Information We Collect
- **Account Information:** Name, email address, phone number, and authentication data.
- **Financial Data:** Loan records, installment tracking, and associated metadata entered by users.
- **Device Information:** Push notification tokens (FCM) to provide alerts.

## 2. How We Use Your Information
We use the collected data strictly to provide, maintain, and improve the Finaculator service.
- **No Marketing:** We do NOT use your personal data, contact information, or financial records for any marketing purposes, third-party advertising, or data brokering.
- We use your phone number and email solely for account authentication, transactional updates, and critical service notifications.

## 3. Data Protection
We implement robust, industry-standard security measures, including data encryption in transit and at rest, to safeguard your financial and personal data.

## 4. Your Rights
You have the right to access, update, or request deletion of your data at any time by contacting support.
    `
  },
  dataPolicy: {
    title: "Data Handling Policy",
    content: `
# Data Handling Policy

**Last Updated:** July 16, 2026
**Version:** v1.0.0

This Data Handling Policy outlines our strict protocols regarding the processing of your financial records.

## 1. Ownership
You retain full ownership of all data you input into Finaculator. We act solely as a data processor to provide you with the ledger service.

## 2. Zero-Marketing Guarantee
We unequivocally state that **none of your data is used for marketing services**. We do not analyze your financial portfolio to offer you third-party loans, nor do we sell your client lists.

## 3. Data Retention and Deletion
Your data is retained as long as your account is active. Upon account deletion, all associated financial records and client data will be permanently purged from our active databases in accordance with our deletion protocols.

## 4. Compliance and Access
Access to backend infrastructure is strictly limited to authorized engineering personnel for maintenance and support purposes only, under strict confidentiality agreements.
    `
  }
};
